import { render, staticRenderFns } from "./DottedPaginator.vue?vue&type=template&id=9ec17ed6&"
import script from "./DottedPaginator.vue?vue&type=script&lang=ts&"
export * from "./DottedPaginator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports